import { render, staticRenderFns } from "./OccupyRecord.vue?vue&type=template&id=b78748f6&scoped=true&"
import script from "./OccupyRecord.vue?vue&type=script&lang=js&"
export * from "./OccupyRecord.vue?vue&type=script&lang=js&"
import style0 from "./OccupyRecord.vue?vue&type=style&index=0&id=b78748f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78748f6",
  null
  
)

export default component.exports